import { render } from "./FooterPart.vue?vue&type=template&id=a5bd7758&scoped=true"
const script = {}

import "./FooterPart.vue?vue&type=style&index=0&id=a5bd7758&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5bd7758"]])

export default __exports__